import {
    GETLOADLIMITLIST_SUCCESS,
    GETLOADLIMITLIST_FAILED,
    RESET_GETLOADLIMITLIST,
    LOADING_GETLOADLIMITLIST,
    NETWORK_ERROR_GETLOADLIMITLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETLOADLIMITLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETLOADLIMITLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETLOADLIMITLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETLOADLIMITLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETLOADLIMITLIST:
            return (state = initialState);
        default:
            return state;
    }
};
